import ModalEditTable from '../CRUDUtils/ModalEditTable';
import { Link } from 'react-router-dom';

export default function DataTypesPage() {
  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
      sorter: (a, b) => a.name.localeCompare(b.name)
    }
  ];

  const formFields = [
    {
      name: 'data_type_id',
      label: 'Data ID',
      type: 'textarea',
      placeholder: 'Data ID',
      disabled: true,
    },
    {
      name: 'name',
      label: 'Name',
      type: 'textarea',
      placeholder: 'name',
      rules: [{ required: true, message: 'Must Enter a Data Type name!' }]
    }
  ];


  return (
    <div className='container-wrapper'>
      <ModalEditTable
        createEndpoint="create/datatypes"
        readEndpoint="read/datatypes"
        editEndpoint="update/datatypes"
        deleteEndpoint="delete/datatypes"
        columns={columns}
        formFields={formFields}
        title="Data Types"
      />
    </div>
  );
}